import identity from 'transmute/identity';
import { InMemoryCache } from '../InMemoryCache';
const PRODUCT_TO_PRODUCT_BUNDLE_ASSOCIATION_ID = 1210;
const LIMIT = 3;
const fetchProductBundleAssociations = (productId, httpClient) => {
  return httpClient.get(`crm-associations/v1/associations/${productId}/HUBSPOT_DEFINED/${PRODUCT_TO_PRODUCT_BUNDLE_ASSOCIATION_ID}`, {
    query: {
      limit: LIMIT
    }
  });
};
const fetchProductsBatch = (objectIds, httpClient) => {
  return httpClient.get('inbounddbproducts/v1/products/batch', {
    query: {
      id: objectIds,
      properties: ['name']
    }
  });
};
const mapProductResponseToProduct = productResponse => {
  return {
    objectId: productResponse.objectId,
    properties: Object.entries(productResponse.properties).reduce((acc, [name, value]) => {
      var _value$value;
      acc[name] = {
        name,
        value: (_value$value = value.value) !== null && _value$value !== void 0 ? _value$value : undefined
      };
      return acc;
    }, {})
  };
};
const fetchProductAssociatedBundles = (productId, httpClient) => {
  return fetchProductBundleAssociations(productId, httpClient).then(({
    results
  }) => fetchProductsBatch(results, httpClient)).then(products => Object.values(products).map(product => mapProductResponseToProduct(product)));
};
export const makeProductAssociatedBundlesCache = () => new InMemoryCache('ProductAssociatedBundlesCache', identity, ({
  httpClient
}) => productId => fetchProductAssociatedBundles(productId, httpClient));